
<div style="display: flex;justify-content: center;margin-top: 30px">
  <div class="container1" style="width: 85%">
    <h2 >Inventario de Menajería</h2>
    <div>
      <mat-form-field appearance="outline" style="width: 100%;height: 50%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="spinner"  >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <div *ngIf="!loading" class="mat-elevation-z8 overflow">
      <table mat-table [dataSource]="dataSource" style="margin-top: 0.4%">

        <ng-container matColumnDef="nombre" >
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>

        <ng-container matColumnDef="marca" >
          <th mat-header-cell *matHeaderCellDef>Marca</th>
          <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
        </ng-container>

        <ng-container matColumnDef="modelo" >
          <th mat-header-cell *matHeaderCellDef>Modelo</th>
          <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
        </ng-container>

        <ng-container matColumnDef="cantidad" >
          <th mat-header-cell *matHeaderCellDef>Cantidad</th>
          <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
        </ng-container>

        <ng-container matColumnDef="proveedor" >
          <th mat-header-cell *matHeaderCellDef>Proveedor</th>
          <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.razonSocial }}</td>
        </ng-container>


        <ng-container matColumnDef="ruc" >
          <th mat-header-cell *matHeaderCellDef>RUC</th>
          <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.ruc }}</td>
        </ng-container>


        <ng-container matColumnDef="numFactura" >
          <th mat-header-cell *matHeaderCellDef>Número de Factura</th>
          <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.numFactura }}</td>
        </ng-container>

        <ng-container matColumnDef="modificar">
          <th mat-header-cell *matHeaderCellDef> Editar </th>
          <td mat-cell *matCellDef="let element;let i=index">
            <button mat-icon-button color="primary" (click)="openDialogModify(element.id)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <!--        <ng-container matColumnDef="eliminar">-->
        <!--          <th mat-header-cell *matHeaderCellDef> Eliminar </th>-->
        <!--          <td mat-cell *matCellDef="let element;let i=index">-->
        <!--            <button mat-icon-button color="primary" (click)="deleteArticulo(i)">-->
        <!--              <mat-icon>delete</mat-icon>-->
        <!--            </button>-->
        <!--          </td>-->
        <!--        </ng-container>-->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>

    </div>
       <div [hidden]="loading">
        <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                       showFirstLastButtons>
        </mat-paginator>
      </div>


      <div *ngIf="!loading" class="row" style="margin-top: 2%" >
        <button mat-raised-button style="background-color: #e95a1a;color: white" (click)="openDialogAdd()">Agregar Menajería</button>
      </div>

  </div>

</div>




